document.addEventListener("DOMContentLoaded", function () {
    let bodyClassList = [...document.body.classList]
    
    if (bodyClassList.includes('page-template-page-races')) {
    // Supprime la valeur de "selectedType" dans le local storage
        if (!localStorage.getItem("selectedType")) {
            // set le type pour le mobile
            localStorage.setItem("selectedType", "europeennes");
        }
        let params = new URLSearchParams(window.location.search);
        if (!params.get("type")) {
            if (window.location.search) {
                window.location.search += "&type=europeennes";
            } else {
                window.location.search = "?type=europeennes";
                let keysToRemove = ["selectedCountry", "selectedDate", "selectedGroup"];
                for (key of keysToRemove) {
                    localStorage.removeItem(key);
                }
            }
        }

        // Fonction pour reset les params de l'URL au click des boutons catégories ("EUROPEENNES, NATIONALES, INTERNATIONALES")
        const buttons = document.querySelectorAll(".js-link-type");
        buttons.forEach(function (button) {
            button.addEventListener("click", function () {
                // Supprime window.location.search
                history.pushState(null, null, window.location.pathname);

                // Supprime la valeur de "myKey" dans le local storage
                let keysToRemove = ["selectedCountry", "selectedDate", "selectedGroup"];

                for (key of keysToRemove) {
                    localStorage.removeItem(key);
                }
            });
        });

        const links = document.getElementsByClassName("js-link");
        if (links) {
            for (let i = 0; i < links.length; i++) {
                links.item(i).addEventListener("click", function (event) {
                    event.preventDefault();

                    let value = links.item(i).getAttribute("data-value");
                    let parameter = links.item(i).getAttribute("data-parameter");

                    if (value && parameter) {
                    const add_params = {};
                    let old_params = new URLSearchParams(window.location.search);
                    if (old_params.get(parameter)) {
                        old_params.set(parameter, value);
                    } else {
                        add_params[parameter] = value;
                    }

                    let base = new URL(window.location.href);
                    let url = new URL(`${base.origin}${base.pathname}?${old_params}`);
                    let new_params = new URLSearchParams([
                        ...Array.from(url.searchParams.entries()),
                        ...Object.entries(add_params),
                    ]).toString();

                    let new_url = new URL(`${url.origin}${url.pathname}?${new_params}`);
                        window.location = new_url;
                    }
                });
            }
        }
    }

    if (bodyClassList.includes('page-template-page-rules')) {
        let params = new URLSearchParams(window.location.search);
        if (!params.get("state")) {
            window.location = '/pays';
        }
    }
});
